import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import resizeWrapper from './resizeWrapper';
import Loader from '../loader';
import entityComposition from '../classes/entityComposition';
const Upload = _ref => {
  let _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? {
      'image/jpeg': []
    } : _ref$accept,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? 'Only .JPG images are allowed' : _ref$errorText,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? null : _ref$helpText,
    loading = _ref.loading,
    onUpload = _ref.onUpload,
    notificationActions = _ref.notificationActions;
  const message = "Failed to upload".concat(errorText ? ":\n".concat(errorText) : ' file');
  const rejection = () => notificationActions.error({
    message
  });
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '100px'
      }
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  let renderedChildren = helpText || 'Click or drop an image file here to upload. Note: only .JPG images are allowed.';
  if (children) {
    renderedChildren =
    /*#__PURE__*/
    // prevent propagation to stop react-dropzonefrom capturing click, opening file picker
    React.createElement("div", {
      onClick: evt => {
        // pre react-dropzone 10, preventDefault was required, not stopPropagation
        // evt.preventDefault();
        evt.stopPropagation();
      },
      role: "presentation"
    }, children);
  }
  return /*#__PURE__*/React.createElement(Dropzone, {
    onDrop: disabled ? () => {} : onUpload,
    noClick: disabled,
    onDropRejected: rejection,
    accept: accept,
    multiple: true // handle multiple files in parent 'onUpload' method to show warning message
    ,
    activeStyle: {
      backgroundColor: 'rgba(0,0,0,0.15)'
    }
  }, _ref2 => {
    let getInputProps = _ref2.getInputProps,
      getRootProps = _ref2.getRootProps;
    return /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
      className: "dropzone t-u-dropzone"
    }), /*#__PURE__*/React.createElement("input", _extends({
      alt: "file-input"
    }, getInputProps())), renderedChildren);
  });
};
Upload.propTypes = {
  accept: PropTypes.shape({}),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  helpText: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onUpload: PropTypes.func.isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export const ResizedUploader = entityComposition(resizeWrapper(Upload), [], {}, ['notification']);
export { Upload as TestUpload };
export default entityComposition(Upload, [], {}, ['notification']);